import React from 'react'
import { Popover } from 'common/styleguide/Popover'
import styles from './NotificationsPopover.scss'
import { NotificationsApp } from 'features/notifications/NotificationsList'
import { FormattedMessage as T } from 'react-intl'

export const NotificationsPopover = ({ target, onRequestClose, intl }) => (
  <Popover noPadding
    intl={intl}
    placement='bottom'
    target={target}
    maxWidth='90vw'
    onRequestClose={onRequestClose}>
    <div className={styles.NotificationsPopover}>
      <div className={styles.header}>
        <strong><T id='notifications.notifications' defaultMessage='Notifications' /></strong>
        <div className={styles.light}>
          <a className={styles.action} href='/notifications'><T id='notifications.viewAll' defaultMessage='View All' /></a>{/* | <a className={styles.action} onClick={this.notDone}>Mark All As Read</a> */}
        </div>
      </div>
      <div className={styles.scroll}>
        <NotificationsApp intl={intl} />
      </div>
    </div>
  </Popover>
)
